/* eslint-disable sort-keys */
/* To determine whether the country is falling under consumer's National Identifier Requested country. For BR this is mandatory
 * consumerNationalIdentifierRequested flag is true for BR
 */
/**
 *
 * @param {string} merchantCountryCode
 * @returns {boolean}
 */
const isNIRequestedCountry = merchantCountryCode => {
  return (merchantCountryCode && merchantCountryCode.toUpperCase() === 'BR') || false;
};

export default isNIRequestedCountry;
